import React, {FC, useMemo} from 'react';
import Slider, {Settings} from 'react-slick';
import SliderArrow from './SliderArrow';

type CardsSliderProps = {
  settings?: Settings
}

const DEFAULT_SETTINGS = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: <SliderArrow />,
  nextArrow: <SliderArrow />,
  className: 'slider'
};

const CardsSlider: FC<CardsSliderProps> = ({children, settings = {}}) => {
  const resultSettings = useMemo(() => ({
    ...DEFAULT_SETTINGS,
    ...settings
  }), [settings]);

  return (
    <Slider {...resultSettings}>{children}</Slider>
  );
};

export default CardsSlider;
